import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { getUserInfo } from 'utils/auth';
import { getSubdomain } from 'utils/helpers/routing';

import NotAuthorizedScreen from 'routes/not-authorized';
import MainLayout from 'components/main-layout/MainLayout';
import { useQuery } from 'react-query';
import { buildClientEntity } from 'utils/helpers/client';
import { useActiveClientContext } from 'store/active-client';
import API from 'core/Api';
import CreateForm from './components/CreateForm';

const Screen: FC = () => {
  const { t } = useTranslation();
  const isOperator = getSubdomain() === 'operators';
  const isLeaveModuleActive = getUserInfo().featureLeavesIsActive;
  const isFeatureShowWFHLeaveTypeInMainDropdown = getUserInfo().featureShowWFHLeaveTypeInMainDropdown;

  interface ISelectOptionProps {
    label: string;
    value: string | number | boolean;
  }
  interface IDropdowns {
    types: ISelectOptionProps[];
    paid_sub_types: ISelectOptionProps[];
    additional_sub_types?: ISelectOptionProps[];
  }

  const { client } = useActiveClientContext();
  const {
    isLoading: isLoadingDropdowns,
    error: errorDropdowns,
    data: dropdowns,
  } = useQuery<IDropdowns, Error>([buildClientEntity('employee-leaves-dropdowns', client)], (): Promise<IDropdowns> => {
    return API.get('leaves/types/dropdown-options').then(
      res =>
        res.data && {
          ...res.data,
        }
    );
  });
  const hasWorkFromOfficeSubType = !!dropdowns?.additional_sub_types?.some(
    option => option.value === 'work_from_office'
  );

  let titleKey = 'leaves.createTitle';
  if (isFeatureShowWFHLeaveTypeInMainDropdown) {
    titleKey = hasWorkFromOfficeSubType ? 'leaves.createTitleWFO' : 'leaves.createTitleWFH';
  }

  if (isLeaveModuleActive || isOperator) {
    return <MainLayout title={t(titleKey)}>{dropdowns && <CreateForm dropdowns={dropdowns} />}</MainLayout>;
  }

  return <NotAuthorizedScreen />;
};

export default Screen;
